import {
    FETCHED_AGE_GROUPS, 
    FETCHED_REVIEWS_BY_SEARCH_TERMS, 
    CLEAR_REVIEWS_SEARCH_FILTER
} from './types';

export function fetchedAgeGroups(ageGroups) {
    return {
        type: FETCHED_AGE_GROUPS,
        payload: ageGroups
    }
}

export function gotReviewsBySearchTerms(reviews) {
    return {
        type: FETCHED_REVIEWS_BY_SEARCH_TERMS,
        payload: reviews
    }
}

export function clearReviewsSearchFilter() {
    return {
        type: CLEAR_REVIEWS_SEARCH_FILTER,
    }
}


// WEBPACK FOOTER //
// ./src/containers/reviews/actions.js